import _ from 'lodash';
import formatTravelMode from './formatTravelMode';

const formatTravelModes = (modes) => modes && _.map(modes, (m) => formatTravelMode(m)).join(', ');

export default formatTravelModes;
